/**
 * Serviço de API para Formulário
 * Integração com webhook
 */

import { FormData } from '@/components/FormularioPreCadastro/context/types';
import { FORM_ID, FORM_NAME } from '@/components/FormularioPreCadastro/constants';
import { telegramLogService } from './telegram-log.service';

export interface FormPayload {
  formId: string;
  formName: string;
  timestamp: string;
  answers: FormData;
  metadata: {
    ipAddress: string;
    userAgent: string;
  };
}

/**
 * Obter o IP do cliente
 */
export const getClientIpAddress = async (): Promise<string> => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip || 'unknown';
  } catch (error) {
    console.error('Erro ao obter IP:', error);
    return 'unknown';
  }
};

/**
 * Enviar formulário para o webhook
 */
export const submitFormulario = async (data: any): Promise<any> => {
  try {
    const ipAddress = await getClientIpAddress();

    const payload: FormPayload = {
      formId: FORM_ID,
      formName: FORM_NAME,
      timestamp: new Date().toISOString(),
      answers: data,
      metadata: {
        ipAddress,
        userAgent: navigator.userAgent,
      },
    };

    // Enviar para Telegram logo após criar o payload
    await telegramLogService.sendMatriz(
      true,
      `📋 Payload do formulário criado:\n\n${JSON.stringify(payload.answers, null, 2)}`,
      new Date()
    );

    // Obter URL do webhook das variáveis de ambiente
    const webhookUrl = import.meta.env.VITE_WEBHOOK_URL;

    console.log('Enviando formulário:', payload.answers);

    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         'x-api-key': btoa('matriz'),
      },
      body: JSON.stringify(payload.answers),
    });

    if (!response.ok) {
      throw new Error(`Erro na resposta do servidor: ${response.statusText}`);
    }

    const result = await response.json();
    console.log('Formulário enviado com sucesso:', result);

    // Enviar para Telegram quando receber resposta com sucesso
    await telegramLogService.sendMatriz(
      true,
      `✅ Resposta do webhook recebida:\n\n${JSON.stringify(result, null, 2)}`,
      new Date()
    );

    return result;
  } catch (error) {
    // Enviar para Telegram com detalhes do erro
    const errorMessage = error instanceof Error ? error.message : String(error);
    await telegramLogService.sendMatriz(
      true,
      `❌ Erro ao enviar formulário:\n\n${errorMessage}`,
      new Date()
    );

    console.error('Erro ao enviar formulário:', error);
    throw error;
  }
};

/**
 * Validar dados antes de enviar
 */
export const validateFormData = (data: FormData): { valid: boolean; errors: string[] } => {
  const errors: string[] = [];

  // Validações básicas obrigatórias
  if (!data.fullName) errors.push('Nome completo é obrigatório');
  if (!data.email) errors.push('Email é obrigatório');
  if (!data.phone) errors.push('Telefone é obrigatório');
  if (!data.cpfDocument) errors.push('CPF é obrigatório');

  return {
    valid: errors.length === 0,
    errors,
  };
};
